module.exports = "<div class=\"tab-pane fade spk-tab-pane\" [ngClass]=\"class\" id=\"{{name}}\" role=\"tabpanel\" attr.aria-labelledby=\"{{name}}\">\r\n  <br />\r\n  <ng-content></ng-content>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/spk/layouts/tabs/spk-tab-pane/spk-tab-pane.component.html
// module id = ./src/app/components/framework/spk/layouts/tabs/spk-tab-pane/spk-tab-pane.component.html
// module chunks = main